module.exports = __webpack_public_path__ + "static/media/HarveyWaroonaReporter-devicecomp-min@2x.3385413a.png";